import { Button, Input } from "@arco-design/web-react";
import { RotateCcw, Search } from "lucide-react";

import type { SysStaffListFilters } from "../types";
import "../../../shared/ui/crmListPageLayout.css";
import "./SysDeptUserPage.css";

type SysStaffFilterPanelProps = {
  filters: SysStaffListFilters;
  errorMessage: string;
  onChange: (filters: SysStaffListFilters) => void;
  onReset: () => void;
  onSearch: () => void;
};

/** 用户筛选区。 */
export function SysStaffFilterPanel({
  filters,
  errorMessage,
  onChange,
  onReset,
  onSearch,
}: SysStaffFilterPanelProps) {
  return (
    <section
      className="crm-list-filter-panel"
      role="search"
      aria-label="用户筛选"
      data-layout="two-tier-responsive"
    >
      <div className="crm-list-filter-fields">
        <div className="crm-list-filter-primary">
          <label className="crm-list-field crm-list-field--lg">
            <span>姓名/账号</span>
            <Input
              placeholder="请输入姓名、昵称或账号"
              value={filters.keyword ?? ""}
              onChange={(keyword) => onChange({ ...filters, keyword })}
            />
          </label>
          <label className="crm-list-field crm-list-field--md">
            <span>手机号</span>
            <Input
              placeholder="请输入手机号"
              value={filters.phone ?? ""}
              onChange={(phone) => onChange({ ...filters, phone })}
            />
          </label>
        </div>
        {errorMessage ? <div className="sys-dept-user-error">{errorMessage}</div> : null}
      </div>
      <div className="crm-list-filter-actions">
        <Button icon={<RotateCcw size={16} />} onClick={onReset}>
          重置
        </Button>
        <Button type="primary" icon={<Search size={16} />} onClick={onSearch}>
          搜索
        </Button>
      </div>
    </section>
  );
}
